/** The soldier skeleton: twelve bones, their parents and rest offsets. Character faces +z. */

import { Vector3 } from 'three';

export const B = {
  root: 0,
  pelvis: 1,
  spine: 2,
  head: 3,
  lUpperArm: 4,
  lForeArm: 5,
  rUpperArm: 6,
  rForeArm: 7,
  lThigh: 8,
  lShin: 9,
  rThigh: 10,
  rShin: 11,
  /** The rifle: its own bone, so each pose can carry, shoulder, cradle or drop it. */
  weapon: 12,
} as const;

export const BONE_COUNT = 13;

/** Rest pose: parent index and offset from the parent, metres, character facing +z. */
export const REST: ReadonlyArray<readonly [parent: number, x: number, y: number, z: number]> = [
  [-1, 0, 0, 0],
  [B.root, 0, 0.88, 0],
  [B.pelvis, 0, 0.12, 0],
  [B.spine, 0, 0.5, 0],
  [B.spine, 0.3, 0.42, 0],
  [B.lUpperArm, 0, -0.3, 0],
  [B.spine, -0.3, 0.42, 0],
  [B.rUpperArm, 0, -0.3, 0],
  [B.pelvis, 0.11, 0, 0],
  [B.lThigh, 0, -0.42, 0],
  [B.pelvis, -0.11, 0, 0],
  [B.rThigh, 0, -0.42, 0],
  [B.spine, 0, 0, 0],
];

export function restWorld(index: number): Vector3 {
  const out = new Vector3();
  let i = index;
  while (i >= 0) {
    const r = REST[i];
    if (!r) break;
    out.x += r[1];
    out.y += r[2];
    out.z += r[3];
    i = r[0];
  }
  return out;
}
